/* Webフォント
---------------------------------------------------------- */
const webfont = () => {
	window.WebFontConfig = {
		google: {
			families: [
				'Noto+Sans+JP:400,500,700,900',
				// 'Noto+Serif+JP:400,600',
				'Montserrat:600,700',
			],
		},
		active: () => {
			sessionStorage.fonts = true;
		},
	};
	(() => {
		let wf = document.createElement('script');
		wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
		wf.type = 'text/javascript';
		wf.async = 'true';
		let s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(wf, s);
	})();
};

/* グローバルナビ
---------------------------------------------------------- */
const gnavAction = () => {
	const body = document.body;
	const gnavOpenClass = 'is-nav-opened';
	const gnavCloseClass = 'is-nav-closed';
	const gnav = document.getElementById('gnav');

	window.addEventListener('touchmove', (e) => {
		if (body.classList.contains(gnavOpenClass) && e.target === gnav) {
			e.preventDefault();
		} else {
			e.stopPropagation();
		}
	}, { passive: false });

	if (body.classList.contains(gnavOpenClass)) {
		body.classList.remove(gnavOpenClass);
		body.classList.add(gnavCloseClass);
	} else {
		body.classList.remove(gnavCloseClass);
		body.classList.add(gnavOpenClass);
	}
};

const entryAction = () => {
	const body = document.body;
	const gnavOpenClass = 'is-entry-opened';
	const gnavCloseClass = 'is-entry-closed';

	window.addEventListener('touchmove', (e) => {
		if (body.classList.contains(gnavOpenClass)) {
			e.preventDefault();
		} else {
			e.stopPropagation();
		}
	}, { passive: false });

	if (body.classList.contains(gnavOpenClass)) {
		body.classList.remove(gnavOpenClass);
		body.classList.add(gnavCloseClass);
	} else {
		body.classList.remove(gnavCloseClass);
		body.classList.add(gnavOpenClass);
	}
};

const gnavToggle = () => {
	const gnavToggle = document.querySelectorAll('.js-gnav-toggle');
	const entryToggle = document.querySelectorAll('.js-entry-toggle');
	const overlay = document.getElementById('overlay');

	// ハンバーガーメニュークリック
	if (gnavToggle !== null) {
		Array.prototype.forEach.call(gnavToggle, (el) => {
			el.addEventListener('click', (e) => {
				gnavAction(e);
			});
		});
	}

	// エントリーボタンクリック
	if (entryToggle !== null) {
		Array.prototype.forEach.call(entryToggle, (el) => {
			el.addEventListener('click', (e) => {
				entryAction(e);
			});
		});
	}

	// 背景クリック
	if (overlay !== null) {
		overlay.addEventListener('click', (e) => {
			entryAction(e);
		});
	}

	window.addEventListener('load', (e) => {
		document.body.classList.add('is-nav-loaded');
	});
};

const gnavAccordion = () => {

	const nav = document.querySelectorAll('.js-nav-accordion');

	nav.forEach((el) => {

		const toggle  = el.querySelector(".js-nav-accordion__toggle");

		toggle.addEventListener("click", () => {
			el.classList.toggle('is-opened');
		})
	});

};

const disableScroll = (el) => {

	const body = document.body;
	const className = 'is-scroll-disabled';

	// el.scrollTop = 1;

	window.addEventListener('touchmove', (event) =>  {
		if( body.classList.contains(className) && event.target === el ){
			event.preventDefault();
		} else {
			event.stopPropagation();
		}
	},{ passive: false });

	// if( body.classList.contains(className) ){
	// 	body.classList.remove(className);
	// } else {
	// 	body.classList.add(className);
	// }

};

/* タブ
---------------------------------------------------------- */
const tab = () => {
	const tab = document.querySelectorAll('.js-tab');

	if (tab.length < 1) return false;

	const url = new URL(window.location.href);
	const params = url.searchParams;
	const defaultHash = tab[0].dataset.defaultHash;
	const active = ( location.hash ) ? location.hash.replace('#', '') : defaultHash;

	Array.prototype.forEach.call(tab, (el, i) => {
		const tab_head = el.querySelectorAll('.js-tab-head');
		const tab_head_child = tab_head[0].children;
		const tab_body = el.querySelectorAll('.js-tab-body');
		const tab_body_child = tab_body[0].children;

		for (let $i = 0; $i < tab_head_child.length; $i++) {
			const tab_head_child_id = tab_body_child[$i].dataset.id;
			const tab_body_child_id = tab_head_child[$i].dataset.id;

			if ( tab_head_child_id === active ) {
				tab_head_child[$i].classList.add('is-active');
			} else {
				tab_head_child[$i].classList.remove('is-active');
			}

			if ( tab_body_child_id === active ) {
				tab_body_child[$i].classList.add('is-active');
			} else {
				tab_body_child[$i].classList.remove('is-active');
			}

			let index = $i;

			tab_head_child[$i].addEventListener('click', (e) => {
				for (let $i = 0; $i < tab_head_child.length; $i++) {
					tab_body_child[$i].classList.remove('is-active');
					tab_head_child[$i].classList.remove('is-active');
				}

				tab_body_child[index].classList.add('is-active');
				tab_head_child[index].classList.add('is-active');
			});
		}
	});

	// stories
	const storiesNav = document.querySelector('.stories-nav');

	if ( storiesNav ) {

		gsap.to('#stories-body', {
			scrollTrigger: {
				trigger: '#stories-body',
				start: 'top+=10% bottom',
				end: 'bottom bottom',
				toggleClass: { targets: 'body', className: 'is-stories-nav-view' },
				// markers: true,
			}
		});

		const storiesNavItem = storiesNav.querySelectorAll('.stories-nav__item');

		storiesNavItem.forEach((nav) => {
			const id = nav.dataset.id;
			const link = nav.querySelector('.stories-nav__link');

			if ( id === active ) {
				nav.classList.add('is-active');
			} else {
				nav.classList.remove('is-active');
			}

			link.addEventListener('click', () => {
				gsap.to(window, { duration: 0, scrollTo: { y: '#stories-body', offsetY: 80 } });
			});
		});
	}

};

window.addEventListener('hashchange', tab, false);

/* スクロール関連
---------------------------------------------------------- */
const progressBar = () => {

  const body = document.body;
  const scrolledClass = 'is-scrolled';
  const downScrolledClass = 'is-down-scrolled';
  const progressBar = document.querySelector('.progress__bar');
  const wrap = document.querySelector('.wrap');
  let startPos = 0;

  const scrolledAction = function() {

    const windowYPos = window.pageYOffset;
    const height = wrap.scrollHeight - document.documentElement.clientHeight;
    const scrolled = (windowYPos / height);

		const scrollTop = Math.max(
			windowYPos,
			document.documentElement.scrollTop,
			document.body.scrollTop
		);

		// スクロール判定
		if (scrollTop > 700) {
			body.classList.add(scrolledClass);
		} else {
			body.classList.remove(scrolledClass);
		}

    // プログレスバー
    progressBar.style.transform = `scale(1, ${scrolled})`;

  }

  window.addEventListener('load', scrolledAction);
  window.addEventListener('scroll', scrolledAction);
  window.addEventListener('touchmove', scrolledAction);

}

/* 要素のフェードイン
---------------------------------------------------------- */
const inView = () => {
	const items = document.querySelectorAll('.js-inview');
	const isInview = 'is-inview';

	if (items.length < 1) return false;

	const cb = (entries, observer) => {
		entries.forEach((entry) => {

			const toggle = entry.target.dataset.inviewToggle;

			// console.log(entry);

			if (entry.isIntersecting) {

				entry.target.classList.add(isInview);

			} else {

				if ( toggle ) {
					entry.target.classList.remove(isInview)
				}

			}

		});
	};

	const options = {
		root: null,
		rootMargin: '0px 0px 0px 0px',
		threshold: [0.1]
	};

	const io = new IntersectionObserver(cb, options);

	items.forEach((item) => {
		io.observe(item);
	});

	const transitionLast = document.querySelectorAll('.transition-last');
	transitionLast.forEach(el => {
		const parent = el.parentElement;
		const next = parent.dataset.next;
		const nextEl = document.querySelector(`.${next}`);

		el.addEventListener('transitionend', () => {
			el.parentElement.classList.add('is-transitionend');

			if ( parent.classList.contains('is-inview') ) {
				if ( !next || next === 'hero-cost' && !isPc() ) return false;
				nextEl.classList.add('is-inview');
			}
		});
	});
};

/* spanWrap
---------------------------------------------------------- */
const spanWrap = () => {

	const targets = document.querySelectorAll('.js-span-wrap-text');

	targets.forEach( target => {
		const nodes = [...target.childNodes];
		const inners = target.querySelectorAll('span');

		if ( inners ) {
			inners.forEach( inner => {
				const childNodes = [...inner.childNodes];
				spanWrapText(inner, childNodes);
			});
		}

		spanWrapText(target, nodes);

		const items = target.querySelectorAll('.s_t');
		const length = items.length;

		items.forEach( (item, i) => {
			const delay = ( target.dataset.delay ) ? i * target.dataset.delay : i * 0.1 ;
			item.style.transitionDelay = `${delay}s`;

			if ( i+1 == length ) {
				item.classList.add('s_t--last');
			}
		});

		const last = document.querySelectorAll('.s_t--last');
		last.forEach( el => {
			el.addEventListener('transitionend', () => {
				if ( target.classList.contains('is-inview') ) {
					target.classList.add('is-transitionend');
				}
			});
		});

	});

	function spanWrapText(target, nodes) {
		let spanWrapText = ""
		nodes.forEach((node, i) => {
			if (node.nodeType == 3) {//テキストの場合
				const text = node.textContent.replace(/\r?\n/g, '');//テキストから改行コード削除
				//spanで囲んで連結
				spanWrapText = spanWrapText + text.split('').reduce((acc, v) => {
					return acc + `<span class="s_t">${v}</span>`
				}, "");
			} else {//テキスト以外
				//<br>などテキスト以外の要素をそのまま連結
				spanWrapText = spanWrapText + node.outerHTML
			}
		});
		target.innerHTML = spanWrapText;
	}

}

/* アコーディオン
---------------------------------------------------------- */
const accordion = () => {

	const details = document.querySelectorAll(".js-details");
	const RUNNING_VALUE = "running";
	const IS_OPENED_CLASS = "is-opened";

	details.forEach((el) => {
		const summary = el.querySelector(".js-summary");
		const content = el.querySelector(".js-content");

		summary.addEventListener("click", (event) => {
			event.preventDefault();

			if (el.dataset.animStatus === RUNNING_VALUE) {
				return;
			}

			if (el.open) {

				el.classList.toggle(IS_OPENED_CLASS);

				const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
				el.dataset.animStatus = RUNNING_VALUE;

				closingAnim.onfinish = () => {
					el.removeAttribute("open");
					el.dataset.animStatus = "";
				};

			} else {

				el.setAttribute("open", "true");
				el.classList.toggle(IS_OPENED_CLASS);
				const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
				el.dataset.animStatus = RUNNING_VALUE;

				openingAnim.onfinish = () => {
					el.dataset.animStatus = "";
				};
			}
		});
	});

	const animTiming = {
		duration: 400,
		easing: "ease-out"
	};

	const closingAnimKeyframes = (content) => [
		{
			height: content.offsetHeight + 'px',
			// opacity: 1,
		}, {
			height: 0,
			// opacity: 0,
		}
	];

	const openingAnimKeyframes = (content) => [
		{
			height: 0,
			// opacity: 0,
		}, {
			height: content.offsetHeight + 'px',
			// opacity: 1,
		}
	];
}

/* gsap
---------------------------------------------------------- */
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const gsapAction = () => {

	const copy = document.querySelector('.js-hero-copy');

	if ( copy ) {

		gsap.to(copy, {
			scrollTrigger: {
				trigger: copy,
				start: 'bottom+=100 bottom',
				end: 'bottom+=100 bottom',
				endTrigger: 'html',
				toggleClass: { targets: '.hero-01', className: 'is-scroll' },
			}
		});

	}

	const parallaxText = document.querySelectorAll('.js-parallax-text');

	if ( parallaxText ) {

		parallaxText.forEach(el => {

			const width = el.scrollWidth;
			const reverse = el.dataset.parallaxReverse;
			const adjust = ( isPc() ) ? 100 : 0 ;
			const x = ( reverse ) ? `${width - window.innerWidth + adjust}px` : `-${width - window.innerWidth + adjust}px`;

			gsap.to(el, {
				x: x,
				scrollTrigger: {
					trigger: el,
					start: `top+=100 bottom`,
					end: "bottom top",
					scrub: 1,
					// markers: true,
				}
			});
		});

	}

}

const scrollPanels = () => {

	const html =document.querySelector('html');
	const body = document.body;
	const pagination = document.querySelectorAll('.js-sticky__pagination');

	if ( pagination[0] ) {
		body.style.setProperty('--active-page', '"01"');
		body.dataset.activePage = '01';
		pagination[0].classList.add('is-active');
	}

	pagination.forEach((el, i) => {
		el.addEventListener('click', (e) => {
			const href = document.querySelector(`${el.getAttribute( 'href' )}`);
			goToSection(href)
			e.preventDefault();
		});
	});

	const scrolling = {
		enabled: true,
		events: 'scroll,wheel,touchmove,pointermove'.split(','),
		prevent: (e) => e.preventDefault(),
		disable() {
			if (scrolling.enabled) {
				scrolling.enabled = false;
				window.addEventListener('scroll', gsap.ticker.tick, { passive: true });
				scrolling.events.forEach((e, i) =>
					(i ? document : window).addEventListener(e, scrolling.prevent, {
						passive: false,
					})
				);
			}
		},
		enable() {
			if (!scrolling.enabled) {
				scrolling.enabled = true;
				window.removeEventListener('scroll', gsap.ticker.tick);
				scrolling.events.forEach((e, i) =>
					(i ? document : window).removeEventListener(e, scrolling.prevent)
				);
			}
		},
	};

	const goToSection = (el, e, anim, i) => {

		window.addEventListener('smoothScroll', () => {
			scrolling.disable();

			setTimeout(() => {
				scrolling.enable();
			}, 1000);
		});

		// document.addEventListener("scrollend", (event) => {
		// 	if ( event.target.activeElement.classList.contains('pagetop__link') ) {
		// 		scrolling.enable();
		// 	}
		// });

		const pagination = document.querySelectorAll('.js-sticky__pagination');
		const els = document.querySelectorAll('.js-scroll-panels');
		const active = Array.prototype.indexOf.call(els, el);
		const activePage = ( '00' + (active + 1) ).slice( -2 );

		if ( activePage <= 4 ) {

			body.style.setProperty('--active-page', `'${activePage}'`);
			pagination.forEach((page) => {
				body.classList.remove('is-pagination-hide');
				page.classList.remove('is-active');
			});

			pagination[active].classList.add('is-active');

		} else {
			body.classList.add('is-pagination-hide');
		}

		if (scrolling.enabled) {
			// skip if a scroll tween is in progress
			scrolling.disable();
			body.classList.remove('is-scrolling-end');
			gsap.to(window, {
				scrollTo: { y: el, autoKill: false },
				onStart: () => { html.classList.remove('smooth') },
				onComplete: () => {
					scrolling.enable();
					body.classList.add('is-scrolling-end');
					body.dataset.activePage = activePage;
					html.classList.add('smooth');
				},
				duration: 0,
			});

			anim && anim.restart();
		}
	};

	const els = document.querySelectorAll('.js-scroll-panels');
	const margin = ( isPc() ) ? 100 : 100;
	const stageMargin = ( isPc() ) ? 100 : 65;

	if ( els.length ) {

		els[0].classList.add('is-active');

		els.forEach((el, i) => {

			const spOnly = el.dataset.spOnly

			if ( isPc() && spOnly ) return false;

			ScrollTrigger.create({
				trigger: el,
				start: `top bottom-=${margin}`,
				end: `bottom top+=${margin}`,
				// endTrigger: endTrigger,
				onEnter: (e) => {
					el.classList.add('is-active');
					if ( i === 0 ) return false;
					goToSection(el)
				},
				onEnterBack: (e) => {
					el.classList.add('is-active');
					if ( i === els.length - 1 ) return false;
					goToSection(el)
				},
				onLeave: () => {
					if ( i === els.length - 1 ) return false;
					el.classList.remove('is-active');
				},
				onLeaveBack: () => {
					if ( i === 0 ) return false;
					el.classList.remove('is-active');
				},
				// toggleClass: { targets: el, className: `is-active` },
				// markers: true,
			});
		});

		ScrollTrigger.create({
			trigger: '.js-sticky__stage',
			// start: "top-=100 top+=100",
			start: `top top+=${stageMargin}`,
			end: "bottom bottom",
			onEnter: () => {
				body.classList.add('is-sticky-stage-start');
			},
			onLeaveBack: () => {
				body.classList.remove('is-sticky-stage-start');
			},
			onEnterBack: () => {
				body.classList.remove('is-sticky-stage-end');
			},
			onLeave: () => {
				body.classList.add('is-sticky-stage-end');
			},
			toggleClass: { targets: body, className: `is-sticky-stage` },
			// markers: true,
		});

	}

};


const gsapLoad = () => {
	window.addEventListener('load', () => {
		gsapAction();
		scrollPanels();
	});
}

/* slider
---------------------------------------------------------- */
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const slider = () => {

	const sliders = document.querySelectorAll('.splide');

	if ( !sliders ) return false;

	const options = {
		hero : {
			type : 'fade',
			arrows: false,
			pagination: false,
			autoplay: true,
			rewind: true,
			drag: false,
			interval: 5000,
			speed: 3000,
			pauseOnHover: false,
		},
	};

	Object.keys(sliders).reverse().forEach( (i) => {
		const name = sliders[i].dataset.splideOption;
		const splide = new Splide( sliders[i] , options[name]);
		splide.mount( { AutoScroll } );;
	});
}

/* factory
---------------------------------------------------------- */
const factory = () => {
	const pins = document.querySelectorAll('.js-pin');
	const cards = document.querySelectorAll('.js-card');
	const anchors = document.querySelectorAll('.js-anchor');
	const bg = document.querySelector('.js-map-bg');

	if ( pins.length === 0 ) return false;

	pins[6].classList.add('is-active');

	if ( cards.length !== 0 ) {
		cards[6].classList.add('is-active');
	}

	if ( anchors.length !== 0 ) {
		anchors[6].classList.add('is-active');
	}


	pins.forEach((pin, pinIndex) => {

		pin.addEventListener('mouseover', () => {

			const dataBg = pin.dataset.bg;

			if ( bg ) {
				bg.dataset.bg = dataBg;
			}

			pins.forEach((pin, pinIndex2) => {
				if ( pinIndex2 === pinIndex  ) {
					pin.classList.add('is-active');
				} else {
					pin.classList.remove('is-active');
				}
			});

			cards.forEach((card, cardIndex) => {
				if ( cardIndex === pinIndex  ) {
					card.classList.add('is-active');
				} else {
					card.classList.remove('is-active');
				}
			});

			anchors.forEach((anchor, anchorIndex) => {
				if ( anchorIndex === pinIndex  ) {
					anchor.classList.add('is-active');
				} else {
					anchor.classList.remove('is-active');
				}
			});

		});

	});

	anchors.forEach((anchor, anchorIndex) => {

		anchor.addEventListener('mouseover', () => {

			const dataBg = anchor.dataset.bg;
			if ( bg ) {
				bg.dataset.bg = dataBg;
			}

			anchors.forEach((anchor, anchorIndex2) => {
				if ( anchorIndex2 === anchorIndex  ) {
					anchor.classList.add('is-active');
				} else {
					anchor.classList.remove('is-active');
				}
			});

			pins.forEach((pin, pinIndex) => {
				if ( anchorIndex === pinIndex  ) {
					pin.classList.add('is-active');
				} else {
					pin.classList.remove('is-active');
				}
			});

		});

	});

	const cardOpen = () => {
		cards.forEach((card) => {
			if ( isPc() ){
				card.setAttribute('open', 'true');
			} else {
				card.removeAttribute('open');
			}
		});
	}

	window.addEventListener('load', cardOpen);
	window.addEventListener('resizeend', cardOpen);

}

/* filters
---------------------------------------------------------- */
const filters = () => {

	const form = document.forms.filters;
	const radio = document.querySelectorAll('.js-radio');
	const select = document.querySelectorAll('.js-select');
	const wrap = document.querySelector('.js-item-wrap');
	const items = document.querySelectorAll('.js-item');
	const clear = document.querySelector('.js-clear');

	if (!form) return false;

	clear.addEventListener(`click`, () => {
		form.major.value = 'all';
		form.work.value = 'all';
		form.product.value = 'all';
		form.majorselect.value = 'all';
		form.workselect.value = 'all';
		form.productselect.value = 'all';

		filtering(form.major.value, form.work.value, form.product.value);
	});

	radio.forEach((el) => {
		el.addEventListener(`change`, () => {
			filtering(form.major.value, form.work.value, form.product.value);
		});
	});

	select.forEach((el) => {
		el.addEventListener(`change`, () => {
			filtering(form.majorselect.value, form.workselect.value, form.productselect.value);
		});
	});

	const filtering = (major = null, work = null, product = null) => {
		// console.log(major, work, product);

		items.forEach((item) => {

			const dataJob = item.dataset.job.split(',') ;
			const dataMajor = item.dataset.major.split(',') ;
			const dataWork = item.dataset.work.split(',') ;
			const dataProduct = ( item.dataset.product ) ? item.dataset.product.split(',')  : [''];

			wrap.classList.add('is-hide');
			wrap.classList.add('is-show');

			setTimeout(() => {
				if ( ( dataMajor.includes(major) || major === 'all' ) && ( dataWork.includes(work) || dataJob.includes(work) || work === 'all' ) && ( dataProduct.includes(product) || product === 'all' ) ) {
					item.classList.remove('is-hide');
				} else {
					item.classList.add('is-hide');
				}
			}, '400')

			setTimeout(() => {
				wrap.classList.remove('is-hide');
			}, '500')

		});

	};
}

/* scrollable
---------------------------------------------------------- */
import ScrollHint from 'scroll-hint'
import 'scroll-hint/css/scroll-hint.css';
const scrollable = () => {
	new ScrollHint('.js-scrollable', {
		i18n: {
			scrollable: 'スクロールできます',
		}
	});

}

//* smoothScroll
//---------------------------------------------------------- */
const smoothScroll = () => {

	const body = document.body;
  const smoothScrollTrigger = document.querySelectorAll('.pagetop__link');
	const smoothScroll = new CustomEvent('smoothScroll');

    for (let i = 0; i < smoothScrollTrigger.length; i++){
      smoothScrollTrigger[i].addEventListener('click', (e) => {

				if ( body.classList.contains( 'is-nav-opened' ) ) {
					body.classList.remove( 'is-nav-opened' )
				}

        e.preventDefault();
        let href = smoothScrollTrigger[i].getAttribute('href');
        let targetElement = document.getElementById(href.replace('#', ''));
        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const gap = ( isPc() ) ? 100 : 65;
        const target = rect + offset - gap;
				window.dispatchEvent(smoothScroll);
        window.scrollTo({
          top: target,
          behavior: 'smooth',
        });
      });
    }

}

//* modal
//---------------------------------------------------------- */
import VenoBox from 'venobox';
import "venobox/dist/venobox.min.css";

const modal = () => {
	if (typeof VenoBox !== 'undefined') {
		const venobox = new VenoBox({
			bgcolor: 'transparent',
			overlayColor: 'rgba(0,45,116,.8)',
			// overlayClose: false,
			onContentLoaded: function(content){
				closeVentListener();
			},
		});

		new VenoBox({
			selector: '.video-links',
		});

		function closeVentListener(){
			const closeme = document.querySelectorAll(".js-modal-close");

			closeme.forEach(function(element){
				element.addEventListener('click', function(e){
					e.preventDefault();
					venobox.close();
				});
			});
		}
	}
}

/* setFillHeight
---------------------------------------------------------- */
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

let vw = window.innerWidth;

window.addEventListener('resize', () => {
  if (vw === window.innerWidth) {
  // 画面の横幅にサイズ変動がないので処理を終える
    return;
  }

  // 画面の横幅のサイズ変動があった時のみ高さを再計算する
  vw = window.innerWidth;
  setFillHeight();
});

/* resizeEnd
---------------------------------------------------------- */
const event = new CustomEvent('resizeend');
const currentWidth = window.innerWidth;
let timeoutID = 0;
let delay = 500;

window.addEventListener("resize", () => {

	if ( currentWidth === window.innerWidth ) return false;

	clearTimeout(timeoutID);
	timeoutID = setTimeout( () => {
		window.dispatchEvent(event);
	}, delay);

}, false);

/* mediaQuery
---------------------------------------------------------- */
const isPc = () => {

	const mq = ( window.matchMedia( "(min-width: 768px)" ).matches ) ? true : false;
	return mq;

}

webfont();
gnavToggle();
gnavAccordion();
tab();
progressBar();
disableScroll();
inView();
spanWrap();
accordion();
gsapLoad();
slider();
filters();
scrollable();
smoothScroll();
modal();
setFillHeight();
// factory();